import { httpsCallable } from 'firebase/functions';
import { CloudFunctions } from '../utils/firebase/firebase';

export const editDoctorFeedbackTreatments = async (
  uid,
  treatments,
  patientId,
  videoId
) => {
  try {
    const updateDoctorFeedbackTreatments = httpsCallable(
      CloudFunctions,
      'updateDoctorFeedbackTreatments'
    );

    const response = await updateDoctorFeedbackTreatments({
      uid,
      treatments,
      patientId,
      videoId,
    });
    if (response.data.status) {
      return response.data.message;
    } else {
      return null;
    }
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const editDoctorFeedbackBehaviours = async (
  uid,
  behaviours,
  patientId,
  videoId
) => {
  try {
    const updateDoctorFeedbackBehaviours = httpsCallable(
      CloudFunctions,
      'updateDoctorFeedbackBehaviours'
    );

    const response = await updateDoctorFeedbackBehaviours({
      uid,
      behaviours,
      patientId,
      videoId,
    });
    if (response.data.status) {
      return response.data.message;
    } else {
      return null;
    }
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const UpdatePatientNotesToVault = async (notes, uid, videoId) => {
  try {
    const updatePatientFeedbackNotes = httpsCallable(
      CloudFunctions,
      'updatePatientFeedbackNotes'
    );

    const response = await updatePatientFeedbackNotes({
      notes,
      uid,
      videoId,
    });
    if (response.data.status) {
      return response.data.message;
    } else {
      return null;
    }
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const UpdatedDoctorFeedbackNotesToVault = async (
  notes,
  uid,
  patientId,
  videoId
) => {
  try {
    const updateDoctorFeedbackNotes = httpsCallable(
      CloudFunctions,
      'updateDoctorFeedbackNotes'
    );

    const response = await updateDoctorFeedbackNotes({
      notes,
      uid,
      patientId,
      videoId,
    });
    if (response.data.status) {
      return response.data.message;
    } else {
      return null;
    }
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const getAllVideosFeedbackData = async (uid) => {
  try {
    const getAllDocNotesForPatient = httpsCallable(
      CloudFunctions,
      'getAllDocNotesForPatient'
    );

    const response = await getAllDocNotesForPatient({
      uid,
    });
    if (response.data.status) {
      return response.data.data;
    } else {
      return null;
    }
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const fetchUserNotificationMessages = async (uid, videoId) => {
  try {
    const getUserNotificationMessages = httpsCallable(
      CloudFunctions,
      'getUserNotificationMessages'
    );

    const response = await getUserNotificationMessages({
      uid,
    });
    if (response.data.status) {
      return response.data.data;
    } else {
      return null;
    }
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const updatePreRegisterUserTreatmentDetails = async (
  uid,
  preRegisterUserId,
  treatmentId,
  treatment
) => {
  try {
    const updatePreRegisterUserTreatmentInfo = httpsCallable(
      CloudFunctions,
      'updatePreRegisterUserTreatmentInfo'
    );
    const response = await updatePreRegisterUserTreatmentInfo({
      uid,
      preRegisterUserId,
      treatmentId,
      treatment,
    });
    if (response.data.status) {
      return response.data.message;
    } else {
      return null;
    }
  } catch (e) {
    console.log(e);
    throw e;
  }
};